{
  "basic_opportunities_page": {
    "advanced_button": "Avancé",
    "create_opportunity_button": "Créer une opportunité",
    "all_opportunities_tab": "Toutes les opportunités"
  },
  "archive_opportunity": {
    "confirm_content": "Cette action ne peut pas être annulée",
    "confirm_title": "Êtes-vous sûr de vouloir archiver cette opportunité ?",
    "archive_title": "Archiver l'opportunité"
  },
  "duplicate_goal": {
    "header": "Dupliquer l'opportunité",
    "aria_label": "dupliquer l'opportunité",
    "title": "Dupliquer l'opportunité"
  },
  "opportunity_grid": {
    "actions_menu": {
      "opportunity_actions": "Actions d'opportunité",
      "actions": "Actions",
      "update": "Mettre à jour",
      "duplicate": "Dupliquer",
      "archive": "Archiver"
    },
    "filters": {
      "assign_to": "Assigner à",
      "referral_source": "Source de référence",
      "date": "Date",
      "search_placeholder": "Rechercher"
    }
  },
  "opportunity_preview": {
    "created_by": "Créé par {{name}} le {{date}}",
    "update_opportunity": "Mettre à jour l'opportunité",
    "create_note": "Créer une note",
    "opportunity_number": "Opportunité #{{trackingNumber}}",
    "opportunity_for": "Opportunité pour",
    "proposal_for": "Proposition pour",
    "industries": "Industries",
    "status": "Statut",
    "internal_owner": "Propriétaire interne",
    "key_contacts": "Contacts clés",
    "title_description": "Titre / Description",
    "tags": "Étiquettes",
    "proposed_fee": "Honoraires proposés",
    "team_involved": "Équipe impliquée",
    "referral_source": "Source de référence",
    "proposal_documents": "Documents de proposition",
    "linked_workspaces": "Espaces de travail liés",
    "share_opportunity": "Partager l'opportunité",
    "duplicate_opportunity": "Dupliquer l'opportunité",
    "archive_opportunity": "Archiver l'opportunité",
    "details": "Détails",
    "history": "Historique",
    "notes": "Notes",
    "link": "Lien",
    "view_original_email": "Voir l'e-mail original"
  },
  "add_document_ui": {
    "add_document_header": "Ajouter un document",
    "add_document_aria_label": "ajouter un document",
    "or_separator": "- ou -"
  },
  "add_urls": {
    "document_urls_label": "URLs de documents (multiples)"
  },
  "custom_status": {
    "show_opportunities_aria": "afficher les opportunités {{name}}",
    "total": "Total",
    "opportunities_short": "Opps",
    "info_more_opportunities": "info : a plus d'opportunités",
    "showing_opportunities_tooltip": "Affichage de {{showing}} opportunités. Basculez vers la vue Liste pour voir toutes les {{total}} opportunités",
    "check_all_opportunities": "Vérifier toutes les {{count}} opportunités",
    "last_interaction": "Dernière interaction :"
  },
  "grid": {
    "loading_alt_text": "Chargement des opportunités"
  },
  "form": {
    "opportunity": "Opportunité",
    "select_company_required": "Sélectionner une entreprise associée *",
    "status": "Statut",
    "key_contacts": "Contacts clés",
    "description": "Description",
    "description_placeholder": "Décrivez votre opportunité en une phrase",
    "tags": "Étiquettes",
    "proposed_fee": "Honoraires proposés",
    "opportunity_date": "Date de l'opportunité",
    "date_placeholder": "date",
    "internal_owner": "Propriétaire interne",
    "internal_owner_placeholder": "Qui sera responsable de cette opportunité ?",
    "team_involved": "Équipe impliquée",
    "team_involved_placeholder": "Équipe impliquée dans cette opportunité ?",
    "referral_source": "Source de référence",
    "referral_source_placeholder": "Qui a référé cette opportunité ?",
    "key_contacts_placeholder": "Contacts clés de l'entreprise associée",
    "company_search_placeholder": "Tapez pour rechercher une entreprise",
    "reassign_opportunity": "Réassigner l'opportunité",
    "reassigned_opportunity": "Opportunité réassignée",
    "company": "Entreprise",
    "key_contacts_optional": "Contacts clés (Optionnel)"
  },
  "view": {
    "opportunity_view_aria": "vue d'opportunité",
    "list_view_aria": "vue liste",
    "board_view_aria": "vue tableau",
    "list": "Liste",
    "board": "Tableau"
  },
  "validation": {
    "company_required": "Veuillez saisir une entreprise"
  },
  "audit_trail": {
    "no_history": "Aucun historique n'est disponible pour cette opportunité"
  },
  "notes": {
    "delete": {
      "confirmation_title": "Êtes-vous sûr de vouloir supprimer cette note ?"
    },
    "actions": {
      "aria_label": "actions de note d'opportunité"
    },
    "added_by": "{{name}} a ajouté une note"
  }
}
